<script setup>
import { ref, onMounted } from "vue";
import { newTour } from "@/utils/shepherd/main";

const props = defineProps({
  tabList: {
    type: Array,
    default: () => [],
  },
  currentTab: {
    type: Object,
    default: () => {},
  },
});

const emit = defineEmits(["change"]);

const listRef = ref(null);

const toggle = (val, index) => {
  emit("change", val);
  newTour();
  scrollToTab(index);
};

const scrollToTab = (index) => {
  // Get the button element
  const button = listRef.value.children[index];

  // Calculate the scroll position
  const scrollPosition =
    button.offsetLeft - window.innerWidth / 2 + button.offsetWidth / 2;

  // Scroll to the calculated position
  listRef.value.scrollTo({
    left: scrollPosition,
    behavior: "smooth",
  });
};

onMounted(() => {
  // Find the index of the current tab
  const currentIndex = props.tabList.findIndex(
    (tab) => tab.name === props.currentTab.name
  );

  // Call the scrollToTab method with the current tab index
  scrollToTab(currentIndex);
});
</script>

<template>
  <ul
    id="shepherd-target-tabs"
    ref="listRef"
    class="flex px-3 text-sm font-medium text-center lg:justify-normal lg:px-0 overflow-x-auto"
  >
    <li
      v-for="(tab, index) in props.tabList"
      :key="index"
      class="min-w-0 flex-1 lg:max-w-[9rem]"
    >
      <button
        :class="
          (props.tabList.length === 1
            ? 'rounded-lg '
            : index === 0
            ? 'rounded-l-lg '
            : index === props.tabList.length - 1
            ? 'rounded-r-lg '
            : '') +
          (currentTab.name === tab.name
            ? 'font-bold bg-accentSecondary'
            : 'font-normal bg-gray-10')
        "
        class="inline-block w-full truncate px-2 py-2 text-sm sm:py-2.5 sm:text-base lg:px-3 lg:py-3 text-primary"
        @click="toggle(tab, index)"
      >
        {{ tab.name }}
      </button>
    </li>
  </ul>
</template>
